import React, { useEffect, useState, useRef } from 'react';
import social from '../assets/images/services/social.png';
import web from '../assets/images/services/web.png';
import landing from '../assets/images/services/landing.png';
import google from '../assets/images/services/google.png';
import fb from '../assets/images/services/fb.png';
import whatsapp from '../assets/images/services/whatsapp.png';
import { Link } from 'react-router-dom';
import 'animate.css'; // Import Animate.css for animations

const HomeServices = () => {
  const [visibleBlocks, setVisibleBlocks] = useState([]); // Track visibility of each block
  const blockRefs = useRef([]); // Refs for each block

  useEffect(() => {
    const currentRefs = [...blockRefs.current]; // Copy refs to a variable

    const observers = currentRefs.map((blockRef, index) => {
      return new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            setVisibleBlocks((prev) => [...prev, index]); // Mark block as visible
          }
        },
        { threshold: 0.2 }
      );
    });

    currentRefs.forEach((blockRef, index) => {
      if (blockRef) {
        observers[index].observe(blockRef);
      }
    });

    return () => {
      currentRefs.forEach((blockRef, index) => {
        if (blockRef) {
          observers[index].disconnect();
        }
      });
    };
  }, []);

  return (
    <>
      <div className='clear-both'>
        <div className="our-services clear-both">
          <div className="max-w-screen-xl mx-auto">
            <div className='text-center pb-8 text-white'>
              <h2 className='text-4xl pb-4'>Our Services</h2>
              <p>Our digital marketing services are designed to help you reach your goals. We offer a wide range of services that include website development, social media marketing, content marketing, search engine optimization, paid advertising, email marketing and more.</p>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 text-center m-4" align="center">
              {[web, fb, google, whatsapp, social, landing].map((image, index) => (
                <div
                  key={index}
                  ref={(el) => (blockRefs.current[index] = el)}
                  className={`servicebox0001 shadow-md shadow-stone-500 ${visibleBlocks.includes(index) ? 'animate__animated animate__fadeIn' : ''}`}
                  style={{ animationDelay: `${index * 0.2}s`, animationDuration: '1s' }}
                >
                  <img alt={`Service ${index + 1}`} src={image} className='w-1/4' />
                  <h3>{["Website Design & Development", "Facebook Ads", "Google Ads", "WhatsApp API Automation", "Social Media Management", "Landing Page Design"][index]}</h3>
                  <p>{[
                    "We create modern, responsive, and user-friendly websites tailored to your brand's identity.",
                    "Maximize your brand's reach with precision-targeted Facebook Ads.",
                    "Boost your visibility on the world's largest search engine with our data-driven Google Ads campaigns.",
                    "Automate responses and drive sales with personalized messaging solutions designed to improve efficiency.",
                    "Build and maintain a strong online presence with our expert social media management.",
                    "Increase conversions with our high-performance landing pages."
                  ][index]}</p>
                </div>
              ))}
            </div>

            <div className='text-center pb-8'>
              <Link to="/services"> <button className='bg-white text-black font-bold py-2 px-4 rounded-full'>View All Services</button></Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default HomeServices